import React from 'react';
import PropTypes from 'prop-types';

export default function Modal(props) {
  let { isOpen, toggle, children, className } = props;
  let modalContentRef = React.createRef();
  const clickOutside = (e) => {
    if (!isOpen) return;
    let modalContent = modalContentRef.current;
    let target = e.target;
    if (modalContent !== target && !modalContent.contains(target)) {
      toggle();
    }
  };
  return (
    <div
      className={`km__c--modal-overlay ${
        isOpen ? 'km__c--modal-is-open' : ''
      } ${className}`}
      onClick={clickOutside}
    >
      <div className='km__c--modal-content' ref={modalContentRef}>
        {children}
      </div>
    </div>
  );
}
Modal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};
Modal.defaultProps = {
  isOpen: false,
};
